import { Component, computed, input } from '@angular/core';
import { ConditionOperator } from '@devices/models';

@Component({
  selector: 'avs-incident-rule-operator',
  templateUrl: './incident-rule-operator.component.html',
})
export class IncidentRuleOperatorComponent {
  operator = input.required<ConditionOperator>();

  protected operatorSymbols = computed(() => this.operator().split(''));
}
